"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveInputValue = void 0;
const react_1 = __importStar(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const typestyle_1 = require("typestyle");
const Colors_1 = require("../../../Colors");
const index_1 = require("../Type/index");
const index_2 = require("../ContextMenu/index");
const ActiveInputValueName_1 = require("./ActiveInputValueName");
const index_3 = require("../components/index");
const index_4 = require("../../../GraphQL/Resolve/index");
const index_5 = require("../../../GraphQL/Convert/index");
const trees_1 = require("../../../state/containers/trees");
const LastField = typestyle_1.style({
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
});
const Name = typestyle_1.style({ fontSize: 10, marginRight: 4, overflow: 'hidden' });
const Type = typestyle_1.style({ fontSize: 10, color: Colors_1.Colors.green[0] });
const OptionsMenuContainer = typestyle_1.style({
    position: 'absolute',
    top: 20,
    zIndex: 2,
});
const placeStringInNode = ({ node, v }) => {
    var _a;
    if (!v) {
        return;
    }
    if (v.length === 2 && v[0] === '[' && v[1] === ']') {
        return [];
    }
    const valueType = index_4.isScalarArgument(node);
    const isObjectArg = (node.data.type === graphql_zeus_1.ValueDefinition.InputValueDefinition && !valueType) || node.data.type === graphql_zeus_1.Value.ObjectValue;
    if ((_a = node.type.options) === null || _a === void 0 ? void 0 : _a.includes(graphql_zeus_1.Options.array)) {
        return index_5.ConvertStringToObject(v);
    }
    if (isObjectArg) {
        return index_5.ConvertStringToObject(v);
    }
    if (valueType) {
        let value = v;
        if (valueType === graphql_zeus_1.Value.StringValue) {
            if (!(v.startsWith(`\"`) && v.endsWith(`\"`))) {
                value = `"${value}"`;
            }
            value = value.slice(1, -1);
        }
        const n = {
            data: {
                type: valueType,
            },
            type: {
                name: valueType,
            },
            name: value,
        };
        return [n];
    }
};
exports.ActiveInputValue = ({ node, inputOpen, inputDisabled, outputOpen, outputDisabled, onInputClick, onOutputClick, last, parentNodeTypeName, isLocked, onDelete, }) => {
    const { tree, setTree } = trees_1.useTreesState();
    const [optionsMenuOpen, setOptionsMenuOpen] = react_1.useState(false);
    const [detailsMenuOpen, setDetailsMenuOpen] = react_1.useState(false);
    return (react_1.default.createElement(index_3.NodeFieldContainer, { className: `NodeType-${parentNodeTypeName} ${last ? LastField : ''} ${inputOpen || outputOpen || optionsMenuOpen ? 'Active' : ''}` },
        !inputDisabled && !isLocked ? (react_1.default.createElement(index_3.FieldPort, { onClick: onInputClick, open: inputOpen, info: {
                message: 'Edit input value directives',
                placement: 'left',
            } })) : (react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' })),
        react_1.default.createElement(index_3.Title, null,
            react_1.default.createElement("div", { className: Name },
                isLocked && react_1.default.createElement("span", null, node.name),
                !isLocked && (react_1.default.createElement(ActiveInputValueName_1.ActiveInputValueName, { afterChange: (newName) => {
                        node.name = newName;
                        setTree(Object.assign({}, tree));
                    }, node: node }))),
            react_1.default.createElement("div", { className: Type },
                react_1.default.createElement(index_1.ActiveType, { type: node.type })),
            react_1.default.createElement(index_3.EditableDefaultValue, { value: index_5.ConvertValueNodeToString(node), style: { fontSize: 10, marginLeft: 5 }, onChange: isLocked
                    ? undefined
                    : (v) => {
                        node.args = placeStringInNode({ v, node });
                        setTree(Object.assign({}, tree));
                    } })),
        !isLocked && (react_1.default.createElement(index_3.FieldPort, { icons: { closed: 'More', open: 'More' }, onClick: () => {
                setDetailsMenuOpen(!detailsMenuOpen);
            } }, detailsMenuOpen && (react_1.default.createElement("div", { className: OptionsMenuContainer },
            react_1.default.createElement(index_3.Menu, { hideMenu: () => setDetailsMenuOpen(false) },
                react_1.default.createElement(index_3.MenuScrollingArea, null,
                    react_1.default.createElement(index_3.DetailMenuItem, { onClick: onDelete }, "Delete"))))))),
        !isLocked && (react_1.default.createElement(index_3.FieldPort, { icons: { closed: 'Arrq', open: 'Arrq' }, onClick: () => {
                setOptionsMenuOpen(!optionsMenuOpen);
            } }, optionsMenuOpen && (react_1.default.createElement("div", { className: OptionsMenuContainer },
            react_1.default.createElement(index_2.NodeTypeOptionsMenu, { hideMenu: () => setOptionsMenuOpen(false), node: node }))))),
        !outputDisabled && (react_1.default.createElement(index_3.FieldPort, { onClick: onOutputClick, open: outputOpen, info: {
                message: `Expand ${node.type.name} details`,
                placement: 'right',
            } })),
        outputDisabled && isLocked && react_1.default.createElement("div", { className: 'NodeFieldPortPlaceholder' })));
};
